export { escapeHtml, formatDate } from "./html";

export abstract class LightElement extends HTMLElement {
  protected abort = new AbortController();
  disconnectedCallback(): void { this.abort.abort(); }
  protected listen<K extends keyof WindowEventMap>(target: Window, type: K, callback: (event: WindowEventMap[K]) => void): void;
  protected listen<K extends keyof HTMLElementEventMap>(target: HTMLElement, type: K, callback: (event: HTMLElementEventMap[K]) => void): void;
  protected listen(target: EventTarget, type: string, callback: (event: Event) => void): void {
    target.addEventListener(type, callback, { signal: this.abort.signal });
  }
}

export function downloadFile(name: string, content: string, type = "text/plain"): void {
  const anchor = document.createElement("a");
  anchor.href = URL.createObjectURL(new Blob([content], { type }));
  anchor.download = name;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(anchor.href), 1000);
}
